import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-3">
            <i className="ri-hashtag mr-1"></i>热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            大家都在讨论
          </h2>
          <p className="mt-2 text-sm text-foreground-500">点击话题标签探索相关内容</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href={topic.href}
              onClick={(e) => handleClick(e, topic.href)}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/50 hover:border-primary-500/30 hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 flex-shrink-0">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}